import { useEffect } from "react";
import Hero from "../components/AboutUs/sections/Hero";
import WhoIsScholarsToday from "../components/AboutUs/sections/WhoIsScholarsToday";
import WhyScholarsTodayExist from "../components/AboutUs/sections/WhyScholarsTodayExist";
import Mentors from "../components/AboutUs/sections/Mentors";
import Values from "../components/AboutUs/sections/Values";
import CTA from "../components/AboutUs/sections/CTA";

const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <WhoIsScholarsToday />
      <WhyScholarsTodayExist />
      <Mentors />
      <Values />
      <CTA />
    </div>
  );
};

export default AboutUsPage;
